module.exports = __webpack_public_path__ + "static/img/2-16-错发退货退款问题选择.12db708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-16-错发退货退款问题选择.png
// module id = 1351
// module chunks = 0